<template>
  <div id="contenedor-usuarios-toolbar">
    <v-toolbar
      flat
      dense>
      <div
        style="width: 350px">
        <custom-text-field
          label="Buscar..."
          append-icon="mdi-magnify"
          clearable
          @keyup="buscar"
          @click:clear="limpiarBuscadorTexto">
        </custom-text-field>
      </div>
      <!-- <filtros></filtros> -->
      <v-spacer></v-spacer>
      <!-- CUADRO DE DIALOGO AGREGAR -->
      <v-btn
        color="primary"
        rounded
        @click="nuevo">
        <v-icon left small>
          mdi-plus
        </v-icon>
        Aregar usuario
      </v-btn>
    </v-toolbar>
    <v-tabs class="text-capitalize mt-4">
      <v-tab :to="{ name: 'catalogoUsuarios' }">Funcionarios</v-tab>
      <v-tab :to="{ name: 'catalogoUsuariosContratistas' }">Contratistas</v-tab>
    </v-tabs>
  </div>
</template>

<script>
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';

export default {
  name: 'ToolBarUsuarios',
  components: {
    // Filtros,
    CustomTextField,
  },
  data() {
    return {
      buscarTexto: null,
      debounce: null,
    };
  },
  methods: {
    buscar(e) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.buscarTexto = e.target.value;
      }, 600);
    },
    limpiarBuscadorTexto() {
      this.buscarTexto = '';
    },
    nuevo() {
      this.$emit('nuevoUsuario');
    },
  },
  watch: {
    buscarTexto: {
      handler() {
        this.$emit('buscar', this.buscarTexto);
      },
    },
  },
};
</script>

<style lang="scss">

</style>
